import { ContainerModule } from "inversify";

import { UserRepository } from "../application/store/user.repository";
import { InMemUserRepository } from "./store/in-mem-user.repository";
import { RestUserRepository } from "./store/rest-user.repository";

export const UserModule = new ContainerModule(({ bind }) => {
  bind(UserRepository).toDynamicValue(() => {
    return process.env.NEXT_PUBLIC_USE_FAKE_IMPLEMENTATIONS === "true"
      ? new InMemUserRepository()
      : new RestUserRepository();
  });
});
